import React, { ReactNode } from "react";
import classes from "./ContentWrapper.module.css";

interface Props {
    children: ReactNode;
    className?: string;
}

const ContentWrapper = ({ className, children }: Props) => {
    return <div className={`${classes.contentWrapper} ${className || ""}`}>{children}</div>;
};

export default ContentWrapper;
